exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right-aside[data-v-5a51f030]{padding:0 20px 10px;width:100%;max-width:100%;min-height:100vh}.right-aside .content-header>h1[data-v-5a51f030]{margin:2px;padding-left:13px;padding-top:12px;font-size:0;line-height:1.5}.right-aside .content-header[data-v-5a51f030]{display:none;margin:-2px -20px 25px;height:55px;background:#f9fafb;-webkit-box-shadow:3px 1px 5px #ccc;box-shadow:3px 1px 5px #ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a51f030","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/right-side.vue
// module id = 4HM+
// module chunks = 1